import { memo } from 'react';
import { useFormikContext } from 'formik';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import { Divider, Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';

const ChequeComponent = (): React.ReactElement => {
  const formContext = useFormikContext<StatementsFormVM>();

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Testo della dichiarazione</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Testo della dichiarazione"
          aria-label="Testo della dichiarazione"
          id="text-declaration"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            spellCheck: true,
            lang: 'it',
          }}
          value={formContext.values?.textDeclaration || ''}
          onChange={(event) => {
            formContext.setFieldValue('textDeclaration', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

ChequeComponent.displayName = 'Cheque component';

const Cheque = memo(ChequeComponent);

export default Cheque;
